import React from 'react';
import { Link } from '@amzn/storm-ui';
import { BANNER_LEVEL, BANNER_TYPE } from 'src/app/slice';
import { LinkTemplate, TextTemplate } from '@amzn/aces-communications-api';
import { clickLinkHandler } from './utils';
import { BannerText } from 'src/features/header/components/Banners/styles';

const AcesTextComponent = ({ component }) => {
  return (
    <BannerText>
      {component.strong ? (
        <strong>{component.text}</strong>
      ) : (
        component.text
      )}{' '}
    </BannerText>
  );
};

const AcesLinkComponent = ({ component, bannerLevel, bannerId }) => {
  return (
    <>
      {component.prefix}
      {component.prefix && <> </>}
      <Link
        href={component.url}
        onClick={() => clickLinkHandler(bannerLevel, bannerId)}
      >
        {component.text}
      </Link>{' '}
    </>
  );
};

const acesComponentMap = {
  Text: AcesTextComponent,
  Link: AcesLinkComponent,
};

export const AcesBannerContent: React.VFC<{
  acesBannerContent: (TextTemplate | LinkTemplate)[];
  bannerLevel: BANNER_LEVEL;
  bannerId: string;
  bannerType: BANNER_TYPE;
}> = ({ acesBannerContent, bannerLevel, bannerId }) => {
  return (
    <>
      {acesBannerContent.map((component, index) => {
        const MappedComponent = acesComponentMap[component.type];
        if (!MappedComponent) {
          return null;
        }
        return (
          <MappedComponent
            component={component}
            bannerLevel={bannerLevel}
            bannerId={bannerId}
            key={`${bannerId}-${index}`}
          />
        );
      })}
    </>
  );
};
